const panel=document.querySelector('.panel'),shade=document.querySelector('.shade');
function closeMenu(){panel.classList.remove('open');shade.classList.remove('open');panel.setAttribute('aria-hidden','true')}
document.querySelector('.menu').onclick=()=>{panel.classList.add('open');shade.classList.add('open');panel.setAttribute('aria-hidden','false')};document.querySelector('.panel-close').onclick=closeMenu;shade.onclick=closeMenu;
document.querySelectorAll('.panel a').forEach(a=>a.onclick=closeMenu);
const grid=document.querySelector('#product-grid'),countline=document.querySelector('#product-count');
if(grid){
  document.querySelectorAll('.filter').forEach(btn=>btn.onclick=()=>{
    document.querySelectorAll('.filter').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    const filter=btn.dataset.filter;
    let visible=0;
    grid.querySelectorAll('.product').forEach(card=>{
      const show=filter==='all'||card.dataset.category===filter;
      card.style.display=show?'':'none';
      if(show)visible++;
    });
    if(countline)countline.textContent=`${visible} pieces`;
  });
}

/* ---- Cart: shared helpers ---- */
const cartCount=document.getElementById('count');
const toast=document.querySelector('.toast');
let toastTimer;
function showToast(msg){
  if(!toast)return;
  toast.textContent=msg;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer=setTimeout(()=>toast.classList.remove('show'),2200);
}
function refreshCartCount(){
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    if(cartCount)cartCount.textContent=cart.item_count;
  }).catch(()=>{});
}
function addToCart(variantId, btn){
  if(!variantId)return;
  if(btn){btn.disabled=true;btn.classList.add('is-loading');}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:variantId,quantity:1}]})
  })
  .then(r=>r.json().then(data=>({ok:r.ok,data})))
  .then(({ok,data})=>{
    if(!ok){
      showToast(data && data.description ? data.description : 'Could not add to bag');
      return;
    }
    showToast('Added to bag');
    refreshCartCount();
  })
  .catch(()=>showToast('Something went wrong'))
  .finally(()=>{
    if(btn){btn.disabled=false;btn.classList.remove('is-loading');}
  });
}

/* ---- Quick add-to-cart buttons on grid cards (home + collection) ---- */
document.querySelectorAll('[data-add-to-cart]').forEach(btn=>{
  btn.addEventListener('click', e=>{
    e.preventDefault();
    addToCart(btn.dataset.variantId, btn);
  });
});

/* ---- Cart page: quantity updates, remove, clear, checkout ---- */
const cartRoot=document.getElementById('cart-root');
if(cartRoot){
  const clearBtn=document.getElementById('cart-clear');
  const updateBtn=document.getElementById('cart-update');
  const checkoutBtn=document.getElementById('cart-checkout');
  function collectUpdates(){
    const updates={};
    document.querySelectorAll('.cart-qty').forEach(inp=>{
      updates[inp.dataset.key]=parseInt(inp.value,10)||0;
    });
    return updates;
  }
  function updateCart(updates){
    return fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({updates})
    }).then(r=>{
      if(!r.ok)throw new Error('update failed');
      return r.json();
    });
  }
  if(clearBtn){
    clearBtn.addEventListener('click', ()=>{
      clearBtn.disabled=true;
      fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
        .then(r=>{if(!r.ok)throw new Error();window.location.reload();})
        .catch(()=>{clearBtn.disabled=false;showToast('Could not clear bag');});
    });
  }
  if(updateBtn){
    updateBtn.addEventListener('click', ()=>{
      updateBtn.disabled=true;
      updateCart(collectUpdates())
        .then(()=>window.location.reload())
        .catch(()=>{updateBtn.disabled=false;showToast('Could not update bag');});
    });
  }
  if(checkoutBtn){
    checkoutBtn.addEventListener('click', ()=>{
      checkoutBtn.disabled=true;
      updateCart(collectUpdates())
        .then(()=>{window.location.href='/checkout';})
        .catch(()=>{checkoutBtn.disabled=false;showToast('Could not proceed to checkout');});
    });
  }
  document.querySelectorAll('.cart-remove').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btn.disabled=true;
      const updates={};
      updates[btn.dataset.key]=0;
      updateCart(updates)
        .then(()=>window.location.reload())
        .catch(()=>{btn.disabled=false;showToast('Could not remove item');});
    });
  });
}
const productForm=document.getElementById('product-form');
if(productForm){
  const variantSelect=document.getElementById('product-variant-select');
  const priceEl=document.getElementById('product-price');
  const buyBtn=document.getElementById('pdp-buy-btn');
  if(variantSelect){
    variantSelect.addEventListener('change', ()=>{
      const opt=variantSelect.options[variantSelect.selectedIndex];
      if(priceEl && opt.dataset.price)priceEl.textContent=opt.dataset.price;
      if(buyBtn){
        const soldOut=opt.disabled;
        buyBtn.disabled=soldOut;
        buyBtn.textContent=soldOut?'Sold out':'Add to bag';
      }
    });
  }
  productForm.addEventListener('submit', e=>{
    e.preventDefault();
    if(!variantSelect || !variantSelect.value)return;
    addToCart(variantSelect.value, buyBtn);
  });
}
